export const CREATE_ERRORS = "CREATE_ERRORS";
export const REMOVE_ERRORS = "REMOVE_ERRORS";
export const GET_ERRORS = "GET_ERRORS";
export const REMOVE_GET_ERRORS = "REMOVE_GET_ERRORS";
export const SET_LOADER = "SET_LOADER";
export const CLOSE_LOADER = "CLOSE_LOADER";
export const REDIRECT_TRUE = "REDIRECT_TRUE";
export const REDIRECT_FALSE = "REDIRECT_FALSE";
export const SET_GET_PIN_MESSAGE = "SET_GET_PIN_MESSAGE";
export const SET_CREATE_PIN_MESSAGE = "SET_CREATE_PIN_MESSAGE";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";
export const SET_PINS = "SET_PINS";